import * as THREE from 'three'
import { Component } from "@ecs/Component";

export class Camera extends Component {
    fov = 75
    near = 0.1
    far = 100
    graphicCamera!: THREE.PerspectiveCamera
    setup(data: any) {

        if (data.fov) this.fov = data.fov
        if (data.near) this.near = data.near
        if (data.far) this.far = data.far

        this.graphicCamera = new THREE.PerspectiveCamera(this.fov, window.innerWidth / window.innerHeight, this.near, this.far)


    }
    start() {
        if (!this.engine.scene.mainCamera) this.engine.scene.mainCamera = this
        this.syncronize()
    }
    resize(width: number, height: number) {
        this.graphicCamera.aspect = width / height
        this.graphicCamera.updateProjectionMatrix()
    }
    onMove(): void {
        this.syncronize()

    }
    update(_dt: number): void {
    }
    syncronize() {
        this.graphicCamera.position.copy(this.transform.position)
        this.graphicCamera.rotation.copy(this.transform.rotation)
        this.graphicCamera.scale.copy(this.transform.scale)
        this.graphicCamera.updateProjectionMatrix()
    }
    render(_dt: number): void {
    }
    onDestroy(): void {
        this.engine.scene.mainCamera = undefined
    }
}